import { GlobalsStoryblok } from '~/types/storyblok-generated';

export enum GeigerLocale {
  DE_DE = 'de-de',
  AT_DE = 'at-de',
  IT_IT = 'it-it',
  RO_RO = 'ro-ro',
}

// The first locale here is the default locale
export const i18nLocales: {
  code: GeigerLocale;
  iso: string;
  market: string;
  lang: string;
  countryName: string;
  languageName: string;
}[] = [
  {
    code: GeigerLocale.DE_DE,
    iso: 'de',
    market: 'de',
    lang: 'de',
    countryName: 'Deutschland',
    languageName: 'Deutsch',
  },
  {
    code: GeigerLocale.AT_DE,
    iso: 'de-AT',
    market: 'at',
    lang: 'de',
    countryName: 'Österreich',
    languageName: 'Deutsch',
  },
  { code: GeigerLocale.IT_IT, iso: 'it', market: 'it', lang: 'it', countryName: 'Italia', languageName: 'Italiano' },
  { code: GeigerLocale.RO_RO, iso: 'ro', market: 'ro', lang: 'ro', countryName: 'România', languageName: 'Lb. română' },
];

/**
 * Takes a locale code and returns a valid locale from the i18nLocales array.
 * Falls back to the default locale if the code is not found.
 * @param code Locale code to validate
 * @returns
 */
export function getValidLocale(code: string) {
  return i18nLocales.find(locale => locale.code === code) ?? i18nLocales[0];
}

/**
 * Get a specific translations string from the Storyblok global data
 */
export function getTranslationString(globals: GlobalsStoryblok, key: string): string {
  if (!globals || !globals.translations) {
    return '';
  }
  return globals.translations.find(entry => entry.key === key)?.value ?? '';
}
